enum ModuleConfig {
  HASH_PASSWORD = 'ModuleHashPassword',
  WALKIN_ORDER = 'ModuleKioskWalkInOrderIsEnabled',
  PHONE_ASK_ENALBED = 'ModuleKioskPhoneAskEnabled',
  PHONE_SKIP_ENABLED = 'ModuleKioskPhoneSkipEnabled',
  NAME_ASK_ENALBED = 'ModuleKioskClientNameAskEnabled',
  NAME_SKIP_ENABLED = 'ModuleKioskClientNameSkipEnabled',
  OFFLINE_PAYMENT_ENABLED = 'ModuleKioskOfflinePaymentEnabled',
  PRODUCT_COMMENTS_ENABLED = 'ModuleProductCommentsEnabled',
  CREDITCARD_TIP_ENABLED = 'ModuleCreditCardTipEnabled',
}

export default ModuleConfig;
